<template>
	<div class="boss-wx">
		<div class="boss-wx-title">微信绑定</div>
		<div class="qrcode" id="qrcode" ref="qrcode"></div>
		<div class="boss-wx-desc">
			请使用微信扫描二维码登录<br>“牛商股份”
		</div>
	</div>
</template>

<script>
import {
	mapGetters,
	mapActions
} from 'vuex'
import QRCode from 'qrcodejs2'

export default {
	name: 'accountEditWx',
	data () {
		return {
			timer:null,
			timerNum: 60
		}
	},
	created(){
		this.WeChatQrCode()
	},
	mounted(){
		this.timer = setInterval(() => {
			this.isBindWx()
		}, 3000)
		// 通过$once来监听定时器
		// 在beforeDestroy钩子触发时清除定时器
		this.$once('hook:beforeDestroy', () => {
			clearInterval(timer)
		})
	},
	methods: {
		...mapActions('user', ['getFrontUserInfo','getUserInfo','getIsBand']),
		async WeChatQrCode () {
			let params = {
				uid:this.userInfo.uid,
				sysOrigin:'LK_BOSS'
			}
			let { data } = await this.getUserInfo(params)
			if(data.isSuccess){
				let  qrcode = data.data
				this.crateQrcode (qrcode)
			}else{
				this.$message.error('二维码获取失败！')
			}
		},
		crateQrcode (qrcode) {
			this.qr = new QRCode('qrcode', {
				width: 282,
				height: 282,
				text: qrcode
			})
		},
		async isBindWx() {
			let params = {
				mobile:this.userInfo.moblie
			}
			let { data } = await this.getIsBand(params)
			if(data.isSuccess){
				if(data.data === 'false') return
				this.$message({
					message: '绑定成功',
					type: 'success'
				})
				this.$parent.pageTabFn('infos')
				clearTimeout(this.timer)
				this.timer = null

			}else{
				console.log('绑定失败！')
			}
		}

	},
	computed: {
		...mapGetters('user', ['userInfo'])
	},
	beforeDestroy() {
		clearTimeout(this.timer)
		this.timer = null
	}
}

</script>


<style lang="scss" scoped>
.boss-wx{
	width: 300px;
	margin: 30px auto 0;
	text-align: center;
}
.boss-wx-title{
	height: 32px;
	font-size: 20px;
	margin-bottom: 20px;
}
.boss-wx-desc{
	padding: 7px 14px;
	font-size: 13px;
	line-height: 25px;
}
.qrcode{
	width: 302px;
	height: 302px;
	border: 1px solid #E2E2E2;
	padding: 10px;
}
</style>
